var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("attachment-row", {
        attrs: {
          title: "BudgetaryEstimate.Investment.ICT.AttachmentTitle",
          attachment: _vm.model.attachment,
          index: 1
        },
        model: {
          value: _vm.model.attachment,
          callback: function($$v) {
            _vm.$set(_vm.model, "attachment", $$v)
          },
          expression: "model.attachment"
        }
      }),
      _vm._v(" "),
      _c("h3", [
        _vm._v(_vm._s(_vm.$t("BudgetaryEstimate.Investment.Funding.Title")))
      ]),
      _vm._v(" "),
      _c("estimates-and-details-control", {
        attrs: {
          id: "funding-breakdown",
          titleKey: "BudgetaryEstimate.Investment.Funding.FundingICT",
          tableKey: "BudgetaryEstimate.Investment.Funding.Entry",
          showColumnTotals: true,
          showRowTotals: true,
          required: true,
          numericInputRules: _vm.profitsNumericInputRules
        },
        model: {
          value: _vm.fundingWrappers,
          callback: function($$v) {
            _vm.fundingWrappers = $$v
          },
          expression: "fundingWrappers"
        }
      }),
      _vm._v(" "),
      _c("h3", [_vm._v(_vm._s(_vm.$t("BudgetaryEstimate.Expenses")))]),
      _vm._v(" "),
      _c("personnel-expenses-control", {
        attrs: {
          personnelExpenses: _vm.model.personnelExpenses,
          features: _vm.features,
          isB: true
        }
      }),
      _vm._v(" "),
      _c("line-control", {
        attrs: {
          id: "project-expenses",
          titleKey: "BudgetaryEstimate.Investment.ICT.ProjectExpenses.Title",
          tableKey: "BudgetaryEstimate.Investment.ICT.ProjectExpenses.Entry",
          required: true
        },
        model: {
          value: _vm.projectExpenses,
          callback: function($$v) {
            _vm.projectExpenses = $$v
          },
          expression: "projectExpenses"
        }
      }),
      _vm._v(" "),
      _c(
        "h3",
        [
          _c("plain-text-control", {
            attrs: { title: "BudgetaryEstimate.Investment.Total.Title" }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("estimates-control", {
        attrs: {
          id: "total-summary",
          titleKey: "BudgetaryEstimate.Investment.Total.Title",
          tableKey: "BudgetaryEstimate.Total.Category",
          srOnlyTitle: true,
          showRowTotals: true,
          showColumnTotals: true,
          totalRowHeader: "BudgetaryEstimate.Total.Difference"
        },
        model: {
          value: _vm.totalSummary,
          callback: function($$v) {
            _vm.totalSummary = $$v
          },
          expression: "totalSummary"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }